import React from 'react';
import PropTypes from 'prop-types';
import appConfig from 'config/app.config';
import {getText, renderMarkdown} from 'helpers/text-helper';
import GameProgress from 'components/ui/game-progress/game-progress';
import QR from 'components/ui/qr/qr';
import Button from 'components/ui/button/button';
import './game-groups.scss';

const GameGroups = ({languageId, deviceInfo, gameData, goToPage}) => {

	return (
		<div className={'GameGroups ' + deviceInfo.orientation}>
			{/* Home btn */}
			<div className="GameGroups-homeBtn" onClick={() => {goToPage('settings');}} />


			{/* Content */}
			<div className='GameGroups-content'>
				<GameProgress 
					languageId={languageId}
					progressStepId={'groups'}
					deviceInfo={deviceInfo}
				/>
				
				<div className='GameGroups-title'>
					<span>{getText('pages_groupsTitle', languageId)}</span>
				</div>

				<div className="GameGroups-qrAndInstructions">
					<div className='GameGroups-qr'>
						<QR 
							role="facilitator"
							deviceInfo={deviceInfo} 
							url={'https://' + appConfig.gameUrl + '/gruppe/' + gameData.id}
						/>
					</div>
					<div className='GameGroups-instructions'>
						{renderMarkdown(getText('pages_groupsText1', languageId))}
					</div>
				</div>
			


				

				<div className='GameGroups-text'>
					{renderMarkdown(getText('pages_groupsText2', languageId))}
				</div>

			</div>

			{/* Back btn */}
			<div className='GameGroups-backBtn'>
				<Button
					text={getText('general_back', languageId)}
					classes={['orange', 'fullHeight']}
					onClick={() => {goToPage('game-intro');}}
				/>
			</div>

			{/* Next btn */}
			<div className='GameGroups-nextBtn'>
				<Button
					text={getText('general_next', languageId)}
					classes={['orange', 'next', 'fullHeight']}
					onClick={() => {goToPage('game-status');}}
				/>
			</div>

		</div>
	);
};

GameGroups.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	gameData: PropTypes.object.isRequired,
	goToPage: PropTypes.func.isRequired
};

export default GameGroups;